import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AlertService } from '../../core';
import { BaseComponent } from '../base.component';
import { ChangesDisplayService } from '../changes/changes-display.service';
import { AlertDialogComponent } from '../dialogs';
import { PayCategoriesService } from './pay-categories.service';
import {
	IChangedFieldDetail,
	INote,
	IPayCategory,
	IPayCategoryEffectiveDate,
	IPayCategoryHistory
} from './pay-categories.type';

@Component({
	selector: 'app-pilotpay-pay-categories-details',
	styleUrls: ['./pay-categories.component.scss'],
	templateUrl: './pay-categories-details.component.html'
})
export class PayCategoriesDetailsComponent extends BaseComponent implements OnInit {
	constructor(
		public dialog: MatDialog,
		protected alertService: AlertService,
		private router: Router,
		private route: ActivatedRoute,
		private payCategoriesService: PayCategoriesService,
		private changeDisplayService: ChangesDisplayService
	) {
		super(alertService);

		this.dialogConfig = new MatDialogConfig();
		this.id = this.route.snapshot.paramMap.get('id');
		this.categoriesType = this.route.snapshot.paramMap.get('categoriesType');
		this.date = this.route.snapshot.paramMap.get('date');
		this.payCategoryHistory = [];
		this.isNeedDiscard = false;

		this.payCategoryId = parseInt(this.id, 10);
		this.payCategory = {
			payCategoryId: 0,
			name: '',
			shortCode: '',
			unit: '',
			exportToWorkday: false,
			isAvailability: false,
			isInstructionGiven: false,
			isFlatRateInstruction: false,
			isIncentive: false,
			isApHours: false,
			isFlightTime: false,
			isVisibleToLoadSpecialists: false,
			workdayPayCode: '',
			factorAmount: 0,
			flatHourlyRate: 0,
			iconName: 'fa-address-book',
			colorName: '#e83f6f',
			effectiveStart: '',
			lastModifiedDate: '',
			effectiveEnd: '',
			notes: []
		};
	}

	public futureChangesToggle: boolean = false;
	public hasFutureChange: boolean = false;
	public historyToggle: boolean = false;
	public result: string = '';
	public icon: string;
	public id: string = '';
	public date: string = '';
	public payCategoryId: number = 0;
	public payPeriods: IPayCategoryEffectiveDate[];
	public categoriesType: string = '';
	public disabled: boolean = false;
	public effectiveStartDate: IPayCategoryEffectiveDate;
	public currentDate: moment.Moment = moment.utc();
	public minDateValue: moment.Moment = moment.utc().startOf('month');
	public payCategory: IPayCategory;
	public payWorkdayCategory: string[] = [
		'FLIGHT MTX',
		'INSTRUCTOR',
		'LOADPAY',
		'ONCALL',
		'PERDIEM',
		'PHONE',
		'PILOT TRICK',
		'RECON'
	];
	public notes: INote[] = [];
	public payCategoryHistory: IChangedFieldDetail[];
	public payCategoryChanges: IChangedFieldDetail[];
	public alertDialogRef: MatDialogRef<AlertDialogComponent>;
	public isNeedDiscard: boolean;
	public deletesPayCategoryNote: INote[] = [];
	public dialogConfig: MatDialogConfig;
	public isArchived: boolean = false;

	private readonly externalFormat: string = 'MMMM Y';
	private readonly internalFormat: string = 'YYYY-MM-DDTHH:mm:ss';
	private postNoteError: boolean;

	public ngOnInit(): void {
		this.getWorkDayCategoryList();
		this.getPayCategoryHistory();
		if (this.payCategoryId && this.categoriesType === 'active') {
			this.getPayCategory();
		} else if (this.id && this.date !== 'now') {
			this.getPayCategoryByDate();
		} else {
			this.getMinimumEffectiveDate();
		}
	}

	/**
	 * isNeedChange
	 */
	public isNeedChange(payCategory?: IPayCategory): void {
		if (payCategory) {
			this.payCategory = payCategory;
		}
		this.isNeedDiscard = true;
	}

	/**
	 * onNotesDelete
	 */
	public onNotesDelete(deletesPayCategoryNote?: INote[]): void {
		if (deletesPayCategoryNote) {
			this.deletesPayCategoryNote = [...[], ...deletesPayCategoryNote];
			this.isNeedChange();
		}
	}

	/**
	 * onNotesChange
	 */
	public onNotesChange(notes?: INote[]): void {
		this.notes = [];
		if (notes && this.payCategoryId) {
			this.payCategory.notes = [...[], ...notes];
			this.notes = [...[], ...notes];
			this.isNeedChange();
		}
		if (notes && this.payCategoryId === 0) {
			this.notes = [...[], ...notes];
			this.isNeedChange();
		}
	}

	/**
	 * getPayCategory
	 */
	public getPayCategory(): void {
		this.payCategoriesService.getPayCategory(this.id).subscribe(
			(DATA: IPayCategory) => {
				if (DATA) {
					this.payCategory = DATA;
					this.deletesPayCategoryNote = [];
					this.getMinimumEffectiveDate();
					this.getPayCategoryFutureChanges();
				} else {
					this.getPayCategoryByDate();
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public getPayCategoryByDate(): void {
		this.payCategoriesService.getPayCategoryByDate(this.id, this.date).subscribe(
			(DATA: IPayCategory) => {
				if (DATA) {
					this.payCategory = DATA;
					this.isArchived = true;
					this.deletesPayCategoryNote = [];
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * getWorkDayCategoryList
	 *
	 */
	public getWorkDayCategoryList(): void {
		this.payCategoriesService.getWorkDayCategoryList().subscribe(
			(DATA: string[]) => {
				if (DATA) {
					this.payWorkdayCategory = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * getPayCategoryHistory
	 *
	 */
	public getPayCategoryHistory(): void {
		this.payCategoryHistory = [];
		this.payCategoriesService.getPayCategoryHistory(this.id).subscribe(
			(DATA: IPayCategoryHistory[]) => {
				if (DATA) {
					const history: IPayCategoryHistory[] = this.changeDisplayService.convertPayCategoryHistoryToChangedFieldDetail(
						DATA
					);
					this.payCategoryHistory = [...this.payCategoryHistory, ...history];
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * getPayCategoryFutureChanges
	 *
	 */
	public getPayCategoryFutureChanges(): void {
		this.payCategoryChanges = [];
		this.payCategoriesService.getPayCategoryFutureChanges(this.id).subscribe(
			(DATA: IPayCategoryHistory[]) => {
				if (DATA) {
					const history: IPayCategoryHistory[] = this.changeDisplayService.convertPayCategoryHistoryToChangedFieldDetail(
						DATA
					);
					this.payCategoryChanges = [...this.payCategoryChanges, ...history];
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * getMinimumEffectiveDate
	 *
	 */
	public getMinimumEffectiveDate(): void {
		this.payCategoriesService.getMinimumEffectiveDate(this.id).subscribe(
			(DATA: { minimumEffectiveDate: string }) => {
				if (DATA && DATA.minimumEffectiveDate) {
					this.hasFutureChange = false;

					const minEffectiveDate: moment.Moment = moment.utc(DATA.minimumEffectiveDate);

					this.effectiveStartDate = {
						externalFormat: minEffectiveDate.format(this.externalFormat),
						internalFormat: minEffectiveDate.format(this.internalFormat)
					};
					this.payPeriods = [this.effectiveStartDate];

					for (let i: number = 1; i < 13; i++) {
						const followingMonth: moment.Moment = minEffectiveDate.clone();
						followingMonth.add(i, 'month');

						this.payPeriods.push({
							externalFormat: followingMonth.format(this.externalFormat),
							internalFormat: followingMonth.format(this.externalFormat)
						});
					}

					const previousDate: string = moment()
						.subtract(1, 'month')
						.set('date', 1)
						.startOf('day')
						.format(this.externalFormat);

					if (this.effectiveStartDate.externalFormat === previousDate) {
						this.payPeriods[0].externalFormat += ' (Previous)';
						this.payPeriods[1].externalFormat += ' (Current)';
					} else {
						this.payPeriods[0].externalFormat += ' (Current)';
					}
				} else {
					this.hasFutureChange = true;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * deletePayCategory
	 */
	public deletePayCategory(): void {
		this.payCategory.lastModifiedDate = this.currentDate.format('YYYY-MM-DDTHH:mm:ss');
		this.payCategory.effectiveStart = this.effectiveStartDate.internalFormat;
		this.payCategoriesService.deletePayCategory(this.id, this.payCategory.effectiveStart).subscribe(
			() => {
				this.payCategory = null;
				this.navigate();
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	/**
	 * deletePayCategoryFutureChanges
	 */
	public deletePayCategoryFutureChanges(): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			modalType: 'deleteFutureChanges',
			name: 'Future Changes'
		};
		if (this.dialog) {
			this.alertDialogRef = this.dialog.open(AlertDialogComponent, this.dialogConfig);
		}
		if (this.alertDialogRef) {
			this.alertDialogRef.beforeClosed().subscribe((result: string) => {
				this.result = result;
			});
			this.alertDialogRef.afterClosed().subscribe((isTrue: boolean) => {
				this.alertDialogRef = null;
				if (isTrue) {
					this.payCategoriesService.deletePayCategoryFutureChanges(this.id).subscribe(
						() => {
							this.payCategoryChanges = [];
							this.getMinimumEffectiveDate();
						},
						(error: HttpErrorResponse) => {
							this.handleError(error);
						}
					);
				}
			});
		}
	}

	/**
	 * createPayCategory
	 */
	public createPayCategory(): void {
		if (
			!this.payCategory ||
			!this.payCategory.name ||
			!this.payCategory.shortCode ||
			!this.payCategory.unit ||
			(this.payCategory.exportToWorkday && !this.payCategory.factorAmount) ||
			(this.payCategory.exportToWorkday && !this.payCategory.workdayPayCode) ||
			(this.payCategory.isFlightTime && !this.payCategory.factorAmount) ||
			(this.payCategory.isFlightTime && !this.payCategory.workdayPayCode)
		) {
			return;
		}

		delete this.payCategory.payCategoryId;
		this.payCategory.effectiveStart = this.effectiveStartDate.internalFormat;
		this.payCategory.lastModifiedDate = this.currentDate.format(this.internalFormat);
		this.payCategoriesService.createPayCategory(this.payCategory).subscribe(
			(DATA: IPayCategory) => {
				if (DATA) {
					this.payCategory = DATA;
					this.createOrDeletePayCategoryNote();
					this.navigate();
				}
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	/**
	 * updatePayCategory
	 */
	public updatePayCategory(id: string): void {
		if (
			!id ||
			!this.payCategory ||
			!this.payCategory.name ||
			!this.payCategory.shortCode ||
			!this.payCategory.unit ||
			(this.payCategory.exportToWorkday && !this.payCategory.factorAmount) ||
			(this.payCategory.exportToWorkday && !this.payCategory.workdayPayCode) ||
			(this.payCategory.isFlightTime && !this.payCategory.factorAmount) ||
			(this.payCategory.isFlightTime && !this.payCategory.workdayPayCode)
		) {
			return;
		}

		this.createOrDeletePayCategoryNote();

		this.payCategory.effectiveStart = this.effectiveStartDate.internalFormat;
		this.payCategory.lastModifiedDate = this.currentDate.format(this.internalFormat);

		this.payCategoriesService.updatePayCategory(id, this.payCategory).subscribe(
			(DATA: IPayCategory) => {
				if (DATA) {
					this.payCategory = DATA;
					if (!this.postNoteError) {
						this.navigate();
					}
				}
			},
			(error: HttpErrorResponse) => {
				this.handleError(error);
			}
		);
	}

	/**
	 * navigate
	 */
	public navigate(): void {
		this.router.navigate(['/pilotpay/pay-categories']);
	}

	/**
	 * Alert Dialog
	 */
	public openAlertDialog(modalType: string): void {
		if (!this.isNeedDiscard && modalType === 'discard') {
			this.navigate();

			return;
		}

		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			modalType: modalType || 'discard',
			name: this.payCategory.name,
			modifiedDate: this.effectiveStartDate.internalFormat
		};

		if (this.dialog) {
			this.alertDialogRef = this.dialog.open(AlertDialogComponent, this.dialogConfig);
		}
		if (this.alertDialogRef) {
			this.alertDialogRef.beforeClosed().subscribe((result: string) => {
				this.result = result;
			});
			this.alertDialogRef.afterClosed().subscribe((isTrue: boolean) => {
				this.alertDialogRef = null;
				if (isTrue && modalType === 'discard') {
					this.navigate();
				} else if (isTrue && modalType === 'delete') {
					this.deletePayCategory();
				}
			});
		}
	}

	/**
	 * createOrDeletePayCategoryNote
	 */
	public createOrDeletePayCategoryNote(): void {
		this.postNoteError = false;

		// delete notes
		this.deletesPayCategoryNote.map((note: INote, index: number) => {
			if (note.payCategoryNoteSettingId) {
				note.order = index;
				this.payCategoriesService
					.deletePayCategoryNote(
						this.id,
						note.payCategoryNoteSettingId,
						this.effectiveStartDate.internalFormat
					)
					.subscribe(
						() => (note.isNeedDelete = true),
						(error: HttpErrorResponse) => {
							this.handleError(error);
							this.postNoteError = true;
						}
					);
			}
		});

		// create notes
		this.notes.forEach((note: INote, index: number) => {
			if (!note.payCategoryNoteSettingId) {
				note.effectiveStart = this.effectiveStartDate.internalFormat;
				note.order = index;

				this.payCategoriesService.createPayCategoryNote(this.payCategory.payCategoryId, note).subscribe(
					(DATA: IPayCategory) => {
						if (DATA) {
							this.payCategory = DATA;
						}
					},
					(error: HttpErrorResponse) => {
						this.handleError(error);
						this.postNoteError = true;
					}
				);
			}
		});

		// update notes
		this.payCategory.notes.map((note: INote, index: number) => {
			if (note.payCategoryNoteSettingId && note.isNeedUpdate) {
				note.effectiveStart = this.effectiveStartDate.internalFormat;
				note.order = index;
				delete note.isNeedUpdate;
				this.payCategoriesService.updatePayCategoryNote(this.id, note.payCategoryNoteSettingId, note).subscribe(
					(DATA: IPayCategory) => {
						if (DATA) {
							this.payCategory = DATA;
						}
					},
					(error: HttpErrorResponse) => {
						this.handleError(error);
						this.postNoteError = true;
					}
				);
			}
		});

		this.deletesPayCategoryNote = this.deletesPayCategoryNote.filter(note => !note.isNeedDelete);
	}
}
